import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LocalizationService } from '../../_core/services/localization.service';

@Pipe({
	name: 'localizedDate',
	pure: false
})
export class LocalizedDatePipe implements PipeTransform {
	constructor(private localizationService: LocalizationService, private datePipe: DatePipe) {}

	transform(value: any, pattern?: string ): any {
		return this.datePipe.transform(value, pattern || this.localizationService.getDefaultDateFormat(), undefined, this.localizationService.getLocaleCode());
	}
}
